import Vue from 'vue'
import moment from 'moment';
import 'moment/locale/pt-br';
import extenso from 'extenso';
import numeral from 'numeral'
import "numeral/locales/pt-br";

import { VueMaskFilter } from 'v-mask'

Vue.filter('VMask', VueMaskFilter);

Vue.filter('decimal', function (value, decimalPlaces = 2) {
  if (!value) {
    var value = 0
  }

  numeral.locale('pt-br');

  return numeral(parseFloat(value)).format('0,0.' + "0".repeat(decimalPlaces))

})

Vue.filter('ucfirst', function (value) {
  if (value) {

    var splitStr = value.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
  }
})


Vue.filter('dateTimeRelative', function (value) {

  if (value == null) {
    return ''
  }

  moment.locale('pt-br')

  return moment(value, "YYYY-MM-DD HH:mm:ss").fromNow();
})

Vue.filter('dateBr', function (value) {

  if (value == null) {
    return ''
  }

  return moment(value, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY')
})

Vue.filter('dateTimeBr', function (value) {

  if (value == null) {
    return ''
  }

  return moment(value, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY HH:mm')
})


Vue.filter('cnpj', function (value) {

  if (value) {

    return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5")

  }

  return ''
})

Vue.filter('phone', function (value) {

  if (value) {

    value = value.replace(/D/g, "");             //Remove tudo o que não é dígito
    value = value.replace(/^(d{2})(d)/g, "($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
    value = value.replace(/(d)(d{4})$/, "$1-$2");    //Coloca hífen entre o quarto e o quinto dígitos
    return value;
  }

  return null
})


Vue.filter('extenso', function (value) {

  if (value) {

    return extenso(value, { mode: 'currency' });

  }

  return null

})

Vue.filter('moneyBr', function (value) {
  if (!value) {
    var value = 0
  }

  var parsedValue = parseFloat(value)
  var value = parsedValue.toFixed(2).split('.');

  value[0] = value[0].split(/(?=(?:...)*$)/).join('.');

  return 'R$ ' + value.join(',')
})


Vue.filter('cpf', function (value) {

  if (value) {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4")
  }

  return ''
})

Vue.filter('cep', function (value) {

  if (value) {
    return value.replace(/(\d{5})(\d{3})/g, "\$1\-\$2")
  }

  return ''
})